import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SidePanel = styled.div`
  flex: 0 0 270px;
`;

export const MainPanel = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;
